import React from "react";
import { Link, useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { polozkyListy, jeAktivni } from "../lib/mobilniNav";

/**
 * Plovoucí dolní lišta z tmavého skla (plátno 16A). Aktivní položka sedí ve
 * světlejší kapsli, která při přepnutí přejede. Svítí vždy nejvýš jedna položka —
 * skupina (Obchod, Ekonomika) je aktivní na kterékoli své stránce.
 */
export default function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const items = polozkyListy(user);
  const aktivni = items.findIndex((i) => jeAktivni(i, pathname));
  if (!items.length) return null;

  return (
    <nav data-testid="mobile-tabbar" aria-label="Hlavní navigace"
      className="lg:hidden fixed z-40 left-3 right-3 md:left-[92px] md:right-6 md:mx-auto md:max-w-[560px] bottom-[var(--lista-dole)] h-16 rounded-[34px] sklo-tm shadow-[0_14px_34px_rgba(20,22,26,.28)]">
      <div className="absolute inset-[5px] flex">
        {/* kapsle aktivní položky */}
        <span aria-hidden="true"
          className="absolute inset-y-0 left-0 rounded-[28px] bg-white/[.14] transition-[transform,opacity] duration-[420ms] ease-[cubic-bezier(.32,.72,0,1)] motion-reduce:transition-none"
          style={{ width: `${100 / items.length}%`, transform: `translateX(${Math.max(aktivni, 0) * 100}%)`, opacity: aktivni < 0 ? 0 : 1 }} />
        {items.map((i, idx) => {
          const Icon = Icons[i.icon] || Icons.Circle;
          const on = idx === aktivni;
          return (
            <Link key={i.key} to={i.cil} data-testid={`tab-${i.key}`} aria-current={on ? "page" : undefined}
              className={`relative z-[1] flex-1 min-w-0 flex flex-col items-center justify-center gap-[3px] text-[10.5px] font-700 transition-colors duration-200 ${
                on ? "text-white" : "text-white/60"}`}>
              <Icon size={21} strokeWidth={1.9} />
              <span className="truncate max-w-full px-0.5">{i.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
